import React, { useEffect, useRef } from "react"

import { extend as applyThree, useThree, useFrame } from "react-three-fiber"
import { apply as applySpring, a, useSpring } from "react-spring/three"

import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer'
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass'
// import { ChromaticAberrationShader } from '../../resources/shaders/ChromaticAberrationShader'

import { FadeShader } from '../../resources/shaders/FadeShader'
import { useAppContext } from "../../context"

applySpring({ EffectComposer, RenderPass, ShaderPass })
applyThree({ EffectComposer, RenderPass, ShaderPass })

const Effects = ({ transitionDuration, transition }) => {
  const { gl, scene, camera, size } = useThree()
  const { pageTransition, ready, setReady} = useAppContext();

  const composer = useRef()
  const { animatedProgress } = useSpring({
    from: ready ? undefined : {animatedProgress: 1},
    to: {animatedProgress: transition || !ready  ? 1 : 0 }, 
    config: {duration: transitionDuration}, 
  });
  
  const myRef = useRef(false);

  useEffect(() => {
    myRef.current = !pageTransition ;
    //console.log("mount", {pageTransition, ready});
    setReady(true);
    return () => {
      //console.log("unmount");
      myRef.current = false;
    };
  }, [pageTransition, ready]);

  useEffect(() => composer.current.setSize(size.width, size.height), [size])
  useFrame(() => myRef.current && gl && composer.current.render(), 1);

  const material = useRef()
  return (
    <effectComposer ref={composer} args={[gl]}>
      <renderPass attachArray="passes" args={[scene, camera]} />
      <a.shaderPass ref={material} attachArray="passes" renderToScreen args={[FadeShader]} uniforms-amount-value={animatedProgress} />
    </effectComposer>
  )
}

export default Effects;